{
  "rti": {
    "preferredAccess": {
      "inspectInPerson": "Inspect documents/records in person",
      "receiveCopies": "Receive copies of documents or records",
      "certifiedSamples": "Receive certified samples of material",
      "digitalOrPrinted": "Receive in digital or printed format"
    }
  },
  "common": {
    "cancel": "Cancel",
    "save": "Save",
    "logout": "Logout",
    "logoutConfirm": "Are you sure you want to log out?",
    "active": "Active",
    "inactive": "Inactive",
    "close": "Close",
    "confirm": "Confirm",
    "delete": "Delete",
    "loading": "Loading…",
    "checking": "Checking…",
    "saving": "Saving…",
    "deleting": "Deleting…",
    "yes": "Yes",
    "no": "No",
    "settingsMenu": "Settings menu",
    "reset": "Reset",
    "search": "Search",
    "previous": "Previous",
    "next": "Next",
    "first": "First",
    "last": "Last",
    "noDataFound": "No data found",
    "noResultsFound": "No Results Found",
    "typeAtLeastLetters": "Type at least {{count}} letters",
    "entries": "entries",
    "showingEntries": "Showing {{from}} to {{to}} of {{total}} {{noun}}",
    "actions": "Actions",
    "status": "Status",
    "back": "Back",
    "rowsPerPage": "Rows per page:",
    "failedToLoad": "Failed to load",
    "selectUser": "Select User",
    "noUsersFound": "No users found",
    "noOptionsFound": "No options found",
    "noStagesFound": "No stages found",
    "noFilesUploaded": "No files uploaded.",
    "noDocumentsDeclared": "No documents declared.",
    "noSubsidiaryTasksAssigned": "No subsidiary tasks assigned.",
    "noPreviousAdviceDocuments": "No previous advice documents uploaded."
  },
  "languages": {
    "english": "English",
    "sinhala": "Sinhala",
    "tamil": "Tamil"
  },
  "validation": {
    "fieldRequired": "{{field}} is required.",
    "maxCharLimit": "Max character limit exceeded.",
    "dateFutureOnly": "Only current and future dates are allowed.",
    "docReasonRequired": "Reason is required when a mandatory document is not uploaded.",
    "contactNumberDigitsOnly": "Contact number must contain digits only.",
    "contactNumberExactLength": "Contact number must be exactly {{count}} digits.",
    "contactNumberMustStartWithZero": "Contact number must start with 0.",
    "validContactNumber": "Enter a valid contact number.",
    "dateOfOffenceFuture": "Date of Offence cannot be in the future.",
    "addAtLeastOnePublicCorporationName": "Add at least one public corporation name."
  },
  "header": {
    "systemName": "Case Management System – AGD",
    "intranetPortal": "Intranet Portal",
    "notifications": "Notifications",
    "userProfile": "User profile",
    "settings": "Settings",
    "info": "Case Scenarios",
    "accountMenu": "Account menu",
    "profile": "Profile",
    "switchRole": "Switch Role",
    "selectUserRole": "Select User Role",
    "switch": "Switch",
    "signOut": "Sign Out",
    "noRolesAvailable": "No roles available",
    "switchRoleFailed": "Could not switch role. Please try again."
  },
  "settings": {
    "theme": "Theme",
    "mode": "Mode",
    "light": "Light",
    "dark": "Dark",
    "primary": "Primary",
    "primaryColor": "Primary color",
    "resetTheme": "Reset theme",
    "language": "Language"
  },
  "nav": {
    "expandNavigation": "Expand Navigation",
    "collapseNavigation": "Collapse Navigation",
    "mainNavigation": "Main Navigation",
    "groups": {
      "dashboard": "Dashboard",
      "work": "Work",
      "operations": "Operations",
      "legalKnowledgeArchiveManagement": "Legal Knowledge Archive Management",
      "legalKnowledgeArchive": "Legal Knowledge Archive",
      "auditLogs": "Audit Logs",
      "administration": "User Administration",
      "workflowManagement": "Workflow Management",
      "reports": "Reports",
      "metadata": "Metadata"
    },
    "tasksAndCases": "Tasks & Cases",
    "caseDetails": "Case Details",
    "attendingTasksAndCases": "Attending Tasks & Cases",
    "assignTasks": "Assign Tasks",
    "escalationTasks": "Escalation Tasks",
    "sgDashboard": "SG Dashboard",
    "operationalDashboard": "Operational",
    "caseRequests": "Case Requests",
    "mailRoom": "Case Submission Requests",
    "recordRoom": "Completed Files",
    "qrScanningLog": "QR Scanning Log",
    "legalKnowledge": "Legal Knowledge Archive",
    "extractedCaseOutcomes": "Extracted Case Outcomes",
    "dashboard": "Dashboard",
    "allIntranetUsers": "Intranet Users",
    "userCategories": "User Categories",
    "allExtranetUsers": "Extranet Users",
    "rolesPermissions": "User Roles & Permissions",
    "dashboards": "Dashboards",
    "auditLogs": "Audit Logs",
    "userPerformanceReport": "User Performance Report",
    "caseTrackingReport": "Case Tracking Report",
    "workflowPerformanceReport": "Workflow Performance Report",
    "workflowTemplates": "Workflow Templates",
    "kpiConfiguration": "KPI Configuration",
    "escalationRules": "Escalation Rules",
    "subcategory": "Sub File Categories",
    "court": "Court Names",
    "language": "Language Types",
    "country": "Countries",
    "nationality": "Nationalities",
    "policeStation": "Police Stations",
    "letterTemplates": "Letter Templates",
    "subsidiaryTasks": "Subsidiary Tasks",
    "caseScenarios": "Case Scenarios"
  },
  "profile": {
    "breadcrumb": "User Profile",
    "title": "User Profile",
    "upload": "Upload",
    "delete": "Delete",
    "name": "Name",
    "emailUsername": "Email Address/Username",
    "emailHint": "This email address will be used as the Username.",
    "userRole": "User Role",
    "userRoles": "User Role(s)",
    "divisionUnit": "Division / Unit",
    "nicPassport": "NIC / Passport No.",
    "designation": "Designation",
    "serviceId": "Service ID No.",
    "contactNumber": "Contact Number",
    "contactPlaceholder": "E.g.: 07X XXX XXXX",
    "systemInformation": "System Information",
    "createdAt": "Created at",
    "createdBy": "Created by",
    "lastUpdatedAt": "Last Updated at",
    "lastUpdatedBy": "Last Updated by",
    "loadingProfile": "Loading profile…",
    "loadFailed": "Failed to load profile.",
    "saveSuccess": "Profile updated successfully.",
    "saveFailed": "Could not save profile.",
    "uploadFailed": "Could not upload profile image.",
    "invalidImage": "Please select a valid image file (JPEG, PNG, or WebP).",
    "imageTooLarge": "Image must be 2 MB or smaller.",
    "profileImageAlt": "Profile photo",
    "deletePhotoTitle": "Remove profile photo",
    "uploading": "Uploading…",
    "uploadImage": "Upload image",
    "maxCharLimit": "Max character limit exceeded.",
    "invalidNicPassport": "Enter a valid NIC or Passport number."
  },
  "confirmDelete": {
    "title": "Confirm delete",
    "message": "Are you sure you want to delete this item? This action cannot be undone.",
    "messageWithEntity": "Delete {{entityLabel}} \"{{entityName}}\"?"
  },
  "legalKnowledge": {
    "status": {
      "draft": "Draft",
      "published": "Published",
      "rejected": "Rejected"
    },
    "archive": {
      "breadcrumb": "Legal Knowledge Archive",
      "title": "Legal Knowledge Archive",
      "subtitle": "Search and view published legal knowledge archive records.",
      "tableTitle": "Legal Knowledge Archive Details",
      "colPublishedAt": "Published at",
      "publishedFrom": "Published From",
      "viewArchivedCaseDetailsTip": "View Archived Case Details",
      "tabsAriaLabel": "Legal knowledge sections",
      "tabOutcomes": "Extracted outcomes",
      "tabSearch": "Search archive",
      "tabLinkages": "Case linkages",
      "tabDashboard": "Dashboard",
      "outcomesTableTitle": "View list of extracted case outcomes",
      "outcomesLegend": "Draft / published / rejected records (FR55)",
      "colCaseRef": "Case / Request Ref.",
      "colCaseType": "Case Type",
      "colOutcomeTitle": "Outcome Title",
      "colPublicationStatus": "Publication Status",
      "colExtractedAt": "Extracted at",
      "colRef": "Ref.",
      "colSummary": "Summary",
      "colFromRef": "From Ref.",
      "colToRef": "To Ref.",
      "colLinkType": "Link Type",
      "colNotes": "Notes",
      "viewDetailsTip": "View details",
      "reviewDraftTip": "Review draft",
      "open": "Open",
      "metadataSearch": "Metadata search",
      "metadataSearchPlaceholder": "Ref., case type, title, keywords…",
      "fullTextSearch": "Full-text search",
      "fullTextSearchPlaceholder": "Words in summary or full narrative…",
      "clear": "Clear",
      "searchResultsTitle": "Search results",
      "linkagesTableTitle": "Related case linkages (FR59)",
      "addLinkage": "Add linkage",
      "analyticsSummary": "Summary (FR60)",
      "totalRecords": "Total records",
      "drafts": "Drafts",
      "recordsByCaseType": "Records by case type",
      "archivedCaseDetails": "Archived case details",
      "reference": "Reference",
      "fullNarrative": "Full narrative",
      "relatedSimilarCases": "Related / similar cases (FR58)",
      "noLinkedReferences": "No linked references on this record.",
      "reviewDraftTitle": "Review case outcome draft (FR56)",
      "outcomeText": "Outcome text",
      "approvePublish": "Approve & publish",
      "retainDraft": "Retain draft",
      "reject": "Reject",
      "addCaseLinkage": "Add case linkage",
      "fromReference": "From reference",
      "toReference": "To reference",
      "selectPlaceholder": "Select…",
      "linkTypeRelatedPrecedent": "Related precedent",
      "linkTypeSimilarSubject": "Similar subject matter",
      "linkTypeFollowOn": "Follow-on matter",
      "chooseDifferentRefs": "Please choose two different reference numbers.",
      "linkageSavedMock": "Linkage saved (mock).",
      "outcomePublishedMock": "Outcome approved and published (mock).",
      "draftRetained": "Draft retained.",
      "draftRejectedMock": "Draft rejected (mock)."
    },
    "outcomes": {
      "title": "Extracted Case Outcomes",
      "tableTitle": "Extracted Case Outcome Details",
      "footerCountNoun": "outcomes",
      "colArchiveRefNo": "Archive Ref. No.",
      "colFileRefNo": "File Ref. No.",
      "colFileCategory": "File Category",
      "colSubFileCategory": "Sub File Category",
      "colOutcomeExtractedAt": "Outcome Extracted at",
      "colCaseCompletedAt": "Case Completed at",
      "editTip": "Edit Draft",
      "editDraftTip": "Edit Draft",
      "viewArchivedTip": "View Archived Case Details",
      "viewTip": "View Archived Case Details",
      "archiveReferenceNumber": "Archive Reference Number",
      "archiveReferenceNumberPlaceholder": "Enter Archive Reference Number",
      "fileReferenceNumber": "File Reference Number",
      "fileReferenceNumberPlaceholder": "Enter File Reference Number",
      "fileCategories": "File Category(s)",
      "fileCategoriesPlaceholder": "Select File Category(s)",
      "subFileCategories": "Sub File Category(s)",
      "subFileCategoriesPlaceholder": "Select Sub File Category(s)",
      "statuses": "Status(s)",
      "statusesPlaceholder": "Select Status(s)",
      "enterText": "Enter Text",
      "enterTextPlaceholder": "Enter Text or Phrase",
      "caseCompletedFrom": "Case Completed From",
      "outcomeExtractedFrom": "Outcome Extracted From"
    },
    "categories": {
      "criminal": "Criminal",
      "civilDivisionAdvise": "Civil Division - Advise",
      "civilDivisionLitigation": "Civil Division - Litigation",
      "civilAppellateDivision": "Civil Appellate Division",
      "criminalAppellateDivision": "Criminal Appellate Division",
      "extraditionMla": "Extradition & MLA",
      "rightToInformation": "Right to Information",
      "publicPetitions": "Public Petitions",
      "nominationRequests": "Nomination Requests",
      "attorneyGeneralInternal": "Attorney General | AGD-Internal"
    },
    "subCategories": {
      "offenceHumanBody": "Offence Affecting Human Body/Life",
      "offenceProperty": "Offence against Property",
      "generalLegalAdvice": "E - General Legal Advice",
      "draftingAgreements": "E - Drafting of Agreements",
      "originalCourt": "OC - Original Court",
      "writPetition": "WP - Writ Petition",
      "mutualLegalAssistance": "MLA - Mutual Legal Assistance",
      "extradition": "EXT - Extradition",
      "courtOfAppeal": "COA - Court of Appeal",
      "supremeCourt": "SC - Supreme Court",
      "highCourtAppeals": "HC - High Court Appeals",
      "supremeCourtAppeals": "SC - Supreme Court Appeals",
      "rtiGeneral": "RTI - General",
      "ppCriminalMatter": "PP - Criminal Matter",
      "ppCivilMatter": "PP - Civil Matter"
    },
    "dashboardPage": {
      "title": "Dashboard",
      "loading": "Loading…",
      "loadFailed": "Failed to load dashboard data.",
      "totalPublished": "Total Published",
      "drafts": "Drafts",
      "rejected": "Rejected",
      "totalPublishedDesc": "Total number of records published to the Legal Knowledge Archive as of",
      "draftsDesc": "Total number of extracted case outcomes in Draft status as of",
      "rejectedDesc": "Total number of extracted case outcomes in Rejected status upon review as of",
      "today": "Today ({{date}})",
      "byCategoryTitle": "Published Records by File Category & Sub File Category",
      "byCategoryDesc": "All records published to the Legal Knowledge Archive categorized by File Category & Sub File Category as of",
      "byPeriodTitle": "Published Records by Period",
      "byPeriodDesc": "All records published to the Legal Knowledge Archive categorized by period as of"
    },
    "viewOutcome": {
      "draftBreadcrumb": "Extracted Case Outcome Draft",
      "draftTitle": "Extracted Case Outcome Draft",
      "recordNotFound": "Record not found.",
      "backToList": "Back to list",
      "retainAsDraft": "Retain as Draft",
      "edit": "Edit",
      "approveAndPublish": "Approve & Publish",
      "backToListBtn": "Back to List",
      "caseOverview": "Case Overview",
      "archiveReferenceNumber": "Archive Reference Number",
      "fileReferenceNumber": "File Reference Number",
      "caseCompletedAt": "Case Completed at",
      "outcomeExtractedAt": "Outcome Extracted at",
      "fileCategory": "File Category",
      "subFileCategory": "Sub File Category",
      "applicableAreas": "Applicable Area(s)",
      "requestSubmittedAt": "Request Submitted at",
      "submittedAgency": "Submitted Agency",
      "divisionName": "Division Name",
      "province": "Province",
      "district": "District",
      "caseNumber": "Case Number",
      "otherExternalRefNos": "Other External Reference Number(s)",
      "connectedAgdFileRefNo": "Connected AGD File Reference Number",
      "description": "Description",
      "courtDetails": "Court Details",
      "courtType": "Court Type",
      "courtName": "Court Name",
      "incidentMatterDetails": "Incident / Matter Details",
      "subjectOfDispute": "Subject of the Dispute",
      "incidentOccurredDate": "Incident Occurred Date",
      "applicableStatutes": "Applicable Statute(s)",
      "statutesPlaceholder": "Applicable Acts, ordinances or any other statutory provisions",
      "notProvided": "Not provided",
      "extractedOutcomeSummary": "Extracted Outcome Summary",
      "summaryPlaceholder": "Extracted outcome summary of this completed case",
      "rejectedReason": "Rejected Reason",
      "caseLinkages": "Case Linkages",
      "addLinkage": "+ Add Linkage",
      "noCaseLinkages": "No case linkages added.",
      "editLinkageTip": "Edit linkage",
      "removeLinkageTip": "Remove linkage",
      "lastUpdatedAt": "Last Updated at",
      "lastUpdatedBy": "Last Updated by",
      "rejectModalTitle": "Reject Extracted Case Outcome Draft",
      "rejectReason": "Reject Reason",
      "rejectReasonPlaceholder": "Enter Reject Reason..",
      "rejectReasonRequired": "Reject reason is required.",
      "editCaseLinkage": "Edit Case Linkage",
      "addNewCaseLinkage": "Add New Case Linkage",
      "linkToArchivedCase": "Link to Archived Case",
      "linkToArchivedCasePlaceholder": "Select the Archive Reference Number of the linked Archived Case",
      "statutesRequired": "Applicable Statute(s) is required.",
      "summaryRequired": "Extracted Outcome Summary is required.",
      "draftRetainedSuccess": "Extracted case outcome retained as draft.",
      "saveFailed": "Failed to save extracted case outcome.",
      "publishSuccess": "Extracted case outcome approved and published.",
      "publishFailed": "Failed to publish extracted case outcome.",
      "rejectSuccess": "Extracted case outcome rejected.",
      "rejectFailed": "Failed to reject extracted case outcome.",
      "linkageSavedSuccess": "Case linkage saved.",
      "linkageSaveFailed": "Failed to save case linkage.",
      "linkageRemovedSuccess": "Case linkage removed.",
      "linkageRemoveFailed": "Failed to remove case linkage.",
      "rejectConfirmTitle": "Confirm Rejection",
      "rejectConfirmMessage": "Are you sure you want to reject this extracted case outcome draft?",
      "cancelConfirmTitle": "Confirm Cancel",
      "cancelConfirmMessage": "Are you sure you want to cancel without saving changes?",
      "removeLinkageConfirmTitle": "Remove Case Linkage",
      "removeLinkageConfirmMessage": "Are you sure you want to remove this case linkage?"
    },
    "viewArchived": {
      "title": "View Archived Case Details",
      "breadcrumb": "View Archived Case Details",
      "back": "Back",
      "backToArchive": "Back to Legal Knowledge Archive",
      "loadFailed": "Failed to load archived case details.",
      "rejectReasonLabel": "Extracted Case Outcome Draft Rejected Reason"
    }
  },
  "viewRequest": {
    "breadcrumbParent": "Tasks & Cases",
    "title": "View Case Request",
    "fileReferenceNumber": "File Reference Number",
    "fileCategory": "File Category",
    "subFileCategory": "Sub File Category",
    "currentStatus": "Current Status",
    "tabCaseDetails": "Case Details",
    "tabDocuments": "Documents",
    "tabCommunications": "Communications",
    "loadingCaseRequest": "Loading case request…",
    "loadingQr": "Loading QR…",
    "qrAlt": "Case request cover note QR code",
    "qrUnavailable": "QR code unavailable",
    "qrTip": "Present this QR code together with the cover note when delivering the physical file to AGD.",
    "viewCoverNote": "View Cover Note",
    "preparing": "Preparing…",
    "printCoverNote": "Print Cover Note",
    "caseRequestIdMissing": "Case request id is missing.",
    "loadFailed": "Failed to load case request.",
    "notFound": "Case request not found.",
    "coverNotePdfFailed": "Cover note PDF could not be loaded.",
    "inProgress": "In Progress",
    "documentsLoadFailed": "Failed to load documents.",
    "communicationsLoadFailed": "Failed to load communications.",
    "loadingDocuments": "Loading documents…",
    "loadingCommunications": "Loading communications…",
    "requestSubmittedAt": "Request Submitted at",
    "applicableAreas": "Applicable Area(s)"
  },
  "admin": {
    "userAdministration": "User Administration",
    "shared": {
      "code": "Code",
      "description": "Description",
      "cancelChanges": "Cancel Changes",
      "cancelChangesMessage": "Are you sure you want to cancel? Any unsaved changes will be lost.",
      "requestFailed": "Request failed.",
      "invalidEmail": "Enter a valid email address.",
      "add": "Add",
      "adding": "Adding…",
      "removeImage": "Remove image",
      "upload": "Upload",
      "imageUploadFailed": "Image upload failed.",
      "displayName": "Display Name",
      "selectStatus": "Select Status",
      "emailPlaceholderShort": "Enter Email Address/Username",
      "agencyName": "Agency Name",
      "roleName": "Role Name",
      "applicationName": "Application Name",
      "applicationNames": "Application Name(s)",
      "assignedUsers": "Assigned Users",
      "fileCategory": "File Category",
      "subFileCategory": "Sub File Category",
      "supervisor": "Supervisor",
      "selectAllPermissions": "Select All Permissions",
      "basicInformation": "Basic Information",
      "orderIndex": "Order Index",
      "dragToReorder": "Drag to reorder",
      "locked": "Locked",
      "loadingOrder": "Loading order…",
      "noPermissionsConfigured": "No permissions configured.",
      "selectedCount": "{{count}} selected",
      "newRole": "New Role",
      "rolePermissions": "Role Permissions",
      "applicationCannotChange": "Application cannot be changed on update."
    },
    "intranetUsers": {
      "title": "Intranet Users",
      "addNewUser": "+ Add New User",
      "tableTitle": "Intranet User Details",
      "selectUserName": "Select User's Name",
      "selectUserRole": "Select User Role",
      "selectDivisionUnit": "Select Division/Unit",
      "emailPlaceholder": "Enter Email Address/Username",
      "selectStatus": "Select Status",
      "filterByUserName": "Filter by user name",
      "userDetails": "User Details",
      "deleteTitle": "Delete user",
      "entityLabel": "user",
      "editUser": "Edit user",
      "deleteUser": "Delete user",
      "loadFailed": "Failed to load users.",
      "deleteSuccess": "User deleted successfully.",
      "deleteFailed": "Failed to delete user.",
      "footerCountNoun": "users"
    },
    "extranetUsers": {
      "title": "Extranet Users",
      "addNewUser": "+ Add New User",
      "tableTitle": "Extranet User Details",
      "selectAgencyName": "Select Agency Name",
      "agencyUserFullName": "Agency User's Full Name",
      "editUser": "Edit User",
      "deleteUser": "Delete User",
      "deleteTitle": "Delete user",
      "entityLabel": "user",
      "loadFailed": "Failed to load users.",
      "deleteSuccess": "User deleted successfully.",
      "deleteFailed": "Failed to delete user.",
      "footerCountNoun": "users"
    },
    "rolesPermissions": {
      "title": "User Roles & Permissions",
      "addNewRole": "+ Add New Role",
      "tableTitle": "User Role Details",
      "selectRoleName": "Select Role Name",
      "selectApplicationName": "Select Application Name",
      "updateRoleDetails": "Update Role Details",
      "viewRoleDetails": "View Role Details",
      "updateNotAllowed": "Update not allowed for this role.",
      "updateNotAllowedAria": "Update Role Details (not allowed)",
      "deleteRole": "Delete Role",
      "deleteTitle": "Delete role",
      "entityLabel": "role",
      "roleDeletedSuccess": "Role deleted successfully.",
      "roleDeleteFailed": "Failed to delete role.",
      "roleCreatedSuccess": "Role created successfully.",
      "roleUpdatedSuccess": "Role updated successfully."
    },
    "userCategories": {
      "title": "User Categories",
      "addUserCategory": "+ Add User Category",
      "tableTitle": "User Category Details",
      "selectFileCategory": "Select File Category",
      "selectSubFileCategory": "Select Sub File Category",
      "selectUserName": "Select User's Name",
      "selectUserRole": "Select User Role",
      "selectSupervisor": "Select Supervisor",
      "selectStateAttorney": "Select State Attorney",
      "editUserCategory": "Edit User Category",
      "loadFailed": "Failed to load user categories.",
      "footerCountNoun": "user categorizations",
      "duplicateCombinationError": "A configuration for \"{{fileCategory}} > {{subFileCategory}}\" already exists. To change the supervisor or users, please update the existing record.",
      "editExistingRecord": "Edit existing record →",
      "duplicateCombinationBlockedTooltip": "This category combination already exists. Use the edit link above."
    },
    "intranetUserForm": {
      "updateTitle": "Update Intranet User",
      "addTitle": "Add New Intranet User",
      "sectionTitle": "Intranet User Details",
      "title": "Title",
      "firstName": "First Name",
      "lastName": "Last Name",
      "selectTitle": "Select Title",
      "firstNamePlaceholder": "E.g.: Nimal",
      "lastNamePlaceholder": "E.g.: Silva",
      "displayNamePlaceholder": "E.g.: Mr. Nimal Silva",
      "emailPlaceholder": "E.g.: name@ag.gov.lk",
      "nicPlaceholder": "E.g.: 901234567V or N1234567",
      "serviceIdPlaceholder": "Enter Service ID Number",
      "selectUserRole": "Select User Role",
      "selectDesignation": "Select Designation",
      "selectUserRoleToAdd": "Select user role to add",
      "addUserRole": "Add user role",
      "noRolesAvailable": "No roles available",
      "addRole": "Add role",
      "selectRoleFirst": "Select a role first",
      "defaultRole": "Default Role",
      "removeRole": "Remove {{roleName}}",
      "atLeastOneRole": "At least one user role must be selected.",
      "noRolesData": "No data found for user roles.",
      "selectRoleThenAdd": "Select a user role, then click + to add it.",
      "roleResolveFailed": "Could not resolve the selected role. Choose a role from the list.",
      "rolesResolveFailed": "One or more roles could not be resolved. Please re-select roles.",
      "selectDefaultRole": "Select a default role.",
      "selectValidDivision": "Please select a valid Division / Unit.",
      "divisionInvalid": "Division / Unit is invalid. Please re-select it.",
      "createSuccess": "Intranet user created successfully.",
      "updateSuccess": "Intranet user updated successfully."
    },
    "extranetUserForm": {
      "allExtranetUsers": "All Extranet Users",
      "updateTitle": "Update Extranet User Details",
      "addTitle": "Add New Extranet User",
      "sectionTitle": "Extranet User Details",
      "extranetAgencyName": "Extranet Agency Name",
      "selectExtranetAgencyName": "Select Extranet Agency Name",
      "addNewAgency": "+ Add New Agency",
      "addNewExtranetAgency": "Add New Extranet Agency",
      "enterExtranetAgencyName": "Enter Extranet Agency Name",
      "agencyNameRequired": "Extranet agency name is required.",
      "selectValidAgency": "Please select a valid Extranet Agency Name.",
      "companyCode": "Company Code",
      "companyCodePlaceholder": "E.g.: ABC",
      "brn": "BRN",
      "brnPlaceholder": "Enter BRN",
      "agencyUserFullName": "Agency User's Full Name",
      "agencyUserFullNamePlaceholder": "Enter Agency User's Full Name",
      "displayNamePlaceholder": "E.g.: Nimal Perera",
      "agencyUserDesignation": "Agency User's Designation",
      "agencyUserDesignationPlaceholder": "Enter Agency User's Designation",
      "contactRequired": "Contact number is required.",
      "createSuccess": "Extranet user created successfully.",
      "updateSuccess": "Extranet user updated successfully."
    },
    "roleForm": {
      "listTitle": "User Roles & Permissions",
      "updateTitle": "Update User Role",
      "viewTitle": "View User Role",
      "addTitle": "Add New User Role",
      "roleNamePlaceholder": "Enter user role's name",
      "codePlaceholder": "E.g.: SYS_AD",
      "descriptionPlaceholder": "Enter user role's description",
      "atLeastOnePermission": "At least one permission must be added.",
      "atLeastOneApplication": "Select at least one application.",
      "codeGenerateFailed": "Code could not be generated. Enter a role name.",
      "cannotInactivateWithAssignedUsers": "This role cannot be marked as Inactive while users are assigned to it.",
      "createSuccess": "Role created successfully.",
      "updateSuccess": "Role updated successfully."
    },
    "userCategoryForm": {
      "updateTitle": "Update User Category",
      "addTitle": "Add User Category",
      "userNames": "User's Name(s)",
      "selectFileCategoryFirst": "Select File Category first",
      "searchSelectUsers": "Search and select users…",
      "noUsersFound": "No users found",
      "createSuccess": "User category created successfully.",
      "updateSuccess": "User category updated successfully."
    }
  },
  "metadata": {
    "subCategories": {
      "title": "Sub File Categories",
      "addSubCategory": "+ Add Sub File Category",
      "tableTitle": "Sub File Category Details",
      "selectFileCategory": "Select File Category",
      "selectSubFileCategory": "Select Sub File Category",
      "updateSubCategory": "Update Subcategory",
      "loadFailed": "Failed to load subcategories.",
      "footerCountNoun": "subcategories"
    },
    "subCategoryForm": {
      "addTitle": "Create Subcategory",
      "updateTitle": "Update Subcategory",
      "bindName": "Bind Name",
      "namePlaceholder": "Enter subcategory name",
      "codePlaceholder": "Generated from name",
      "codeLengthError": "Code must be 3–5 uppercase characters.",
      "applicableArea": "Applicable Area",
      "applicableAreaItemPlaceholder": "Enter applicable area",
      "addApplicableArea": "Add applicable area",
      "applicableAreaEmptyAddBlocked": "Enter an applicable area before adding another.",
      "applicableAreaDuplicateError": "This applicable area already exists.",
      "removeApplicableArea": "Remove applicable area",
      "documentTypes": "Document Types",
      "documentOptional": "Optional",
      "documentOptionalHint": "When checked, this document is not required for the subcategory checklist.",
      "selectAllDocumentTypes": "Select All Document Types",
      "createSuccess": "Subcategory created successfully.",
      "updateSuccess": "Subcategory updated successfully."
    },
    "courts": {
      "title": "Court Names",
      "addCourt": "+ Add Court Name",
      "tableTitle": "Court Name Details",
      "courtName": "Court Name",
      "courtNamePlaceholder": "Enter Court Name",
      "courtCode": "Court Code",
      "courtType": "Court Type",
      "division": "Division",
      "province": "Province",
      "district": "District",
      "selectCourtType": "Select Court Type",
      "selectDivision": "Select Division",
      "selectProvince": "Select Province",
      "selectDistrict": "Select District",
      "selectProvinceFirst": "Select Province first",
      "selectStatus": "Select Status",
      "updateCourt": "Update Court Name",
      "loadFailed": "Failed to load court names.",
      "footerCountNoun": "court names"
    },
    "courtForm": {
      "addTitle": "Add Court Name",
      "updateTitle": "Update Court Name",
      "namePlaceholder": "Enter Court Name",
      "selectCourtType": "Select Court Type",
      "selectDivision": "Select Division",
      "cancelConfirm": "Are you sure you want to cancel without saving changes?",
      "createSuccess": "Court name added successfully.",
      "updateSuccess": "Court name updated successfully."
    },
    "languages": {
      "title": "Language Types",
      "addLanguage": "+ Add Language Type",
      "tableTitle": "Language Type Details",
      "languageName": "Language Type",
      "languageCode": "Language Code",
      "updateLanguage": "Update Language Type",
      "loadFailed": "Failed to load language types.",
      "footerCountNoun": "language types"
    },
    "languageForm": {
      "addTitle": "Add Language Type",
      "updateTitle": "Update Language Type",
      "namePlaceholder": "Enter Language Type",
      "cancelConfirm": "Are you sure you want to cancel without saving changes?",
      "createSuccess": "Language type added successfully.",
      "updateSuccess": "Language type updated successfully."
    },
    "countries": {
      "title": "Countries",
      "addCountry": "+ Add Country",
      "tableTitle": "Country Details",
      "countryName": "Country Name",
      "countryNamePlaceholder": "Enter country name",
      "countryCode": "Country Code",
      "description": "Description",
      "displayOrder": "Display Order",
      "selectStatus": "Select Status",
      "updateCountry": "Update Country",
      "loadFailed": "Failed to load countries.",
      "footerCountNoun": "countries"
    },
    "countryForm": {
      "addTitle": "Create Country",
      "updateTitle": "Update Country",
      "namePlaceholder": "Enter country name",
      "descriptionPlaceholder": "Enter description",
      "cancelConfirm": "Are you sure you want to cancel without saving changes?",
      "createSuccess": "Country created successfully.",
      "updateSuccess": "Country updated successfully."
    },
    "nationalities": {
      "title": "Nationalities",
      "addNationality": "+ Add Nationality",
      "tableTitle": "Nationality Details",
      "nationalityName": "Nationality",
      "nationalityNamePlaceholder": "Enter Nationality Name",
      "nationalityCode": "Code",
      "description": "Description",
      "descriptionPlaceholder": "Enter Description",
      "displayOrder": "Display Order",
      "updatedAt": "Updated At",
      "selectStatus": "Select Status",
      "updateNationality": "Update Nationality",
      "viewTitle": "Nationality Details",
      "loadFailed": "Failed to load nationalities.",
      "footerCountNoun": "nationalities"
    },
    "nationalityForm": {
      "addTitle": "Create Nationality",
      "updateTitle": "Update Nationality",
      "namePlaceholder": "Enter Nationality Name",
      "cancelConfirm": "Are you sure you want to cancel without saving changes?",
      "createSuccess": "Nationality created successfully.",
      "updateSuccess": "Nationality updated successfully."
    },
    "policeStations": {
      "title": "Police Stations",
      "addPoliceStation": "+ Add Police Station",
      "tableTitle": "Police Station Details",
      "name": "Police Station",
      "code": "Code",
      "policeDivision": "Police Division",
      "district": "District",
      "selectDistrict": "Select District",
      "selectPoliceDivision": "Select Police Division",
      "updatePoliceStation": "Update Police Station",
      "loadFailed": "Failed to load police stations.",
      "footerCountNoun": "police stations"
    },
    "policeStationForm": {
      "addTitle": "Create Police Station",
      "updateTitle": "Update Police Station",
      "name": "Name",
      "namePlaceholder": "Enter police station name",
      "nameLengthError": "Name must not exceed 100 characters.",
      "policeDivision": "Police Division",
      "selectPoliceDivision": "Select Police Division",
      "description": "Description",
      "descriptionPlaceholder": "Enter description",
      "active": "Active",
      "createSuccess": "Police station created successfully.",
      "updateSuccess": "Police station updated successfully."
    },
    "letterTemplates": {
      "title": "Letter Templates",
      "tableTitle": "Letter Template Details",
      "templateName": "Letter Template Name",
      "lastUpdatedAt": "Last Updated at",
      "lastUpdatedBy": "Last Updated by",
      "selectFileCategory": "Select File Category",
      "selectFileCategoryFirst": "Select File Category first",
      "selectSubFileCategory": "Select Sub File Category",
      "selectSubFileCategoryFirst": "Select Sub File Category first",
      "selectTemplateName": "Select Letter Template Name",
      "selectStatus": "Select Status",
      "editTemplateName": "Edit Template Name",
      "loadFailed": "Failed to load letter templates.",
      "footerCountNoun": "letter templates"
    },
    "letterTemplateForm": {
      "updateTitle": "Edit Template Name",
      "namePlaceholder": "Enter letter template name",
      "viewTemplate": "View Letter Template",
      "previewUnavailable": "Letter template preview is unavailable.",
      "cancelConfirm": "Are you sure you want to cancel without saving changes?",
      "updateSuccess": "Letter template updated successfully."
    },
    "subsidiaryTasks": {
      "title": "Subsidiary Tasks",
      "addSubsidiaryTask": "+ Add Subsidiary Task",
      "tableTitle": "Subsidiary Task Details",
      "subsidiaryTask": "Subsidiary Task",
      "description": "Description",
      "lastUpdatedAt": "Last Updated At",
      "selectSubsidiaryTask": "Select Subsidiary Task",
      "selectStatus": "Select Status",
      "editSubsidiaryTask": "Edit Subsidiary Task",
      "loadFailed": "Failed to load subsidiary tasks.",
      "footerCountNoun": "subsidiary tasks"
    },
    "subsidiaryTaskForm": {
      "addTitle": "Add New Subsidiary Task",
      "updateTitle": "Edit Subsidiary Task",
      "namePlaceholder": "Enter subsidiary task",
      "descriptionPlaceholder": "Enter description",
      "cancelConfirm": "Are you sure you want to cancel without saving changes?",
      "createSuccess": "Subsidiary task added successfully.",
      "updateSuccess": "Subsidiary task updated successfully."
    },
    "caseScenarios": {
      "title": "Case Scenarios",
      "addCaseScenario": "+ Add Case Scenario",
      "tableTitle": "Case Scenario Details",
      "titleColumn": "Title",
      "description": "Description",
      "lastUpdatedAt": "Last Updated At",
      "selectTitle": "Select Title",
      "selectStatus": "Select Status",
      "editCaseScenario": "Edit Case Scenario",
      "loadFailed": "Failed to load case scenarios.",
      "footerCountNoun": "case scenarios",
      "infoPanelTitle": "Case Scenarios",
      "infoEmpty": "No case scenarios are available.",
      "infoLoadFailed": "Could not load case scenarios."
    },
    "caseScenarioForm": {
      "addTitle": "Add New Case Scenario",
      "updateTitle": "Edit Case Scenario",
      "titlePlaceholder": "Enter title",
      "descriptionPlaceholder": "Enter description",
      "uploadPdf": "Upload",
      "upload": "Upload",
      "view": "View",
      "viewDocument": "Preview {{name}}",
      "removeDocument": "Remove {{name}}",
      "uploading": "Uploading…",
      "remove": "Remove",
      "removePdfTitle": "Remove PDF",
      "removePdfConfirm": "Are you sure you want to remove the uploaded PDF document?",
      "removeSuccess": "PDF document removed successfully.",
      "removeFailed": "Could not remove the PDF document.",
      "removing": "Removing…",
      "pdfRequired": "Upload is required.",
      "uploadFailed": "Could not upload the PDF document.",
      "cancelConfirm": "Are you sure you want to cancel without saving changes?",
      "createSuccess": "Case scenario added successfully.",
      "updateSuccess": "Case scenario updated successfully."
    }
  },
  "tasks": {
    "shared": {
      "fileRefNo": "File Ref. No.",
      "fileCategory": "File Category",
      "subFileCategory": "Sub File Category",
      "submittedAgency": "Submitted Agency",
      "taskStatus": "Task Status",
      "currentWorkflowStage": "Current Workflow Stage",
      "timeRemaining": "Time Remaining/ Overdue Time",
      "urgencyLevel": "Urgency Level",
      "assignedOfficer": "Assigned Officer",
      "allocationOfficer": "Allocation Officer",
      "caseNumber": "Case Number",
      "submittedAt": "Submitted at",
      "createdAt": "Created at",
      "supervisor": "Supervisor",
      "currentAssignee": "Current Assignee",
      "overdueTime": "Overdue Time",
      "taskDetails": "Task Details",
      "duplicateCase": "Duplicate Case",
      "duplicating": "Duplicating",
      "transferCase": "Transfer Case",
      "transferring": "Transferring",
      "downloadCoverNote": "Download Cover Note",
      "continueDraft": "Continue Draft",
      "opening": "Opening",
      "removeDraft": "Remove Draft",
      "viewTaskCaseDetails": "View Task/ Case Details",
      "updateTaskCaseDetails": "Update Task/ Case Details",
      "retrievePhysicalFile": "Retrieve Physical File",
      "markAsRead": "Mark as Read",
      "markAsUnread": "Mark as Unread",
      "updating": "Updating",
      "viewTaskCaseDetailsShort": "View Task/Case Details",
      "configureAssignment": "Configure Assignment",
      "linkedCasesTitle": "Linked Case(s)",
      "viewLinkedCases": "View linked cases",
      "linkedCasesUnavailable": "No linked cases available",
      "noLinkedCases": "No linked cases for this task.",
      "previousBack": "‹ Back",
      "nextForward": "Next ›"
    },
    "cases": {
      "breadcrumb": "Tasks & Cases",
      "title": "Tasks & Cases",
      "createCaseRequest": "Create Case Request",
      "loadFailed": "Could not load tasks and cases.",
      "notificationUpdateFailed": "Could not update notification status.",
      "duplicateFailed": "Failed to duplicate case. Please try again.",
      "duplicateSuccess": "Case duplicated successfully. A new draft has been created.",
      "transferFailed": "Failed to transfer case. Please try again.",
      "transferSuccess": "Case transferred successfully. The litigation draft has been opened.",
      "deleteDraftFailed": "Failed to delete draft.",
      "deleteDraftSuccess": "Draft deleted successfully.",
      "retrievalFailed": "Failed to request physical file retrieval.",
      "retrievalSuccess": "Physical file retrieval initiated. Record Room has been notified.",
      "deleteTitle": "Delete Case Request",
      "deleteMessage": "Are you sure you want to delete? This action cannot be undone.",
      "activeTab": "Active Tasks & Cases",
      "completedTab": "Completed Tasks & Cases",
      "myActiveTab": "My Active Tasks & Cases",
      "linkedActiveTab": "My Linked Active Tasks & Cases",
      "createdCaseRequestsTab": "Created Case Requests",
      "tableTitle": "Task & Case Details",
      "newNotificationLegend": "New notification received",
      "forwardedTaskLegend": "Forwarded task",
      "newSubTaskLegend": "New sub task assigned"
    },
    "assign": {
      "breadcrumb": "Assign Tasks",
      "breadcrumbAssigned": "Assign Tasks — Assigned Tasks",
      "breadcrumbUnassigned": "Assign Tasks — Unassigned Tasks",
      "breadcrumbReallocation": "Assign Tasks — Re-allocation Requests",
      "title": "Assign Tasks",
      "subtitle": "Manage unassigned tasks, re-allocation requests, and assigned task allocations.",
      "unassignedTab": "Unassigned Tasks",
      "assignedTab": "Assigned Tasks",
      "reallocationTab": "Re-allocation Requests",
      "reasonToRequestReallocation": "Reason to Request Re-allocation",
      "reallocationRequestedBy": "Re-allocation Requested By",
      "reallocationRequestedAt": "Re-allocation Requested at",
      "allocationModeLabel": "Allocation mode",
      "manualAllocation": "Manual Allocation",
      "roundRobinAllocation": "Round Robin Allocation",
      "configureAssignment": "Configure Assignment",
      "counsel": "Counsel",
      "counselRequired": "Counsel is required.",
      "stateAttorney": "State Attorney",
      "stateAttorneyRequired": "State Attorney is required.",
      "selectUserRequired": "Select User is required.",
      "supervisorRequired": "Supervisor is required.",
      "userTaskIdRequired": "User task id is required.",
      "assignmentFailed": "Assignment failed.",
      "assignmentSuccess": "Assignment saved successfully.",
      "cancelAssignmentTitle": "Cancel User Assignment",
      "cancelAssignmentMessage": "Are you sure you want to cancel? Any unsaved changes will be lost.",
      "noUsersFound": "No users found",
      "selectToReassign": "Select to Reassign",
      "selectAllFiltered": "Select All Filtered",
      "selectToReassignRow": "Select {{ref}} to reassign",
      "reassignNow": "Reassign Now",
      "reassignLater": "Reassign Later",
      "reassignNowInfo": "Select a Counsel, Supervisor and State Attorney to reassign the selected case(s) to.",
      "reassignNowConfirmTitle": "Confirm Reassignment",
      "reassignNowConfirmIntro": "For the selected {{count}} Case(s), following users have been selected:",
      "reassignNowConfirmCounselLine": "1. Counsel - {{name}}",
      "reassignNowConfirmSupervisorLine": "2. Supervisor - {{name}}",
      "reassignNowConfirmStateAttorneyLine": "3. State Attorney - {{name}}",
      "reassignNowConfirmProceed": "Once you confirm, the selected {{count}} Case(s) will be assigned to these users. Are you sure to proceed?",
      "reassignLaterInfo": "By selecting to reassign later, the selected case(s) will be removed from the current allocated/assigned officer upon confirmation. After that, these cases will appear under the 'Unassigned Tasks' tab as allocation-pending cases, waiting to be reassigned.",
      "bulkReassignSuccess": "Selected case(s) reassigned successfully.",
      "bulkReassignFailed": "Bulk reassignment failed.",
      "reassignNowConfirmTitle": "Confirm Reassignment",
      "reassignNowConfirmIntro": "For the selected {{count}} Case(s), following users have been selected:",
      "reassignNowConfirmOutro": "Once you confirm, the selected {{count}} Case(s) will be assigned to these users. Are you sure to proceed?",
      "selectCasesToReassign": "Select at least one case to reassign.",
      "mixedCategoryReassignError": "Selected cases must share the same file category and sub file category."
    },
    "escalation": {
      "breadcrumb": "Escalation Tasks",
      "breadcrumbAssigned": "Escalation Tasks — Assigned Tasks",
      "breadcrumbUnassigned": "Escalation Tasks — Unassigned Tasks",
      "title": "Escalation Tasks",
      "subtitle": "Review escalated tasks pending reassignment and tasks already assigned after escalation.",
      "unassignedTab": "Unassigned Tasks",
      "assignedTab": "Assigned Tasks",
      "escalatedAt": "Escalated at"
    },
    "attending": {
      "breadcrumb": "Attending Tasks & Cases",
      "title": "Attending Tasks & Cases",
      "tableTitle": "Task Details",
      "loadFailed": "Could not load attending tasks and cases."
    },
    "managementAssistant": {
      "breadcrumb": "Case Details",
      "title": "Case Details",
      "tableTitle": "Task & Case Details",
      "tabActive": "Active Tasks & Cases",
      "tabCreated": "Created Case Requests",
      "tabCompleted": "Completed Task & Cases",
      "createdAt": "Created At",
      "loadFailed": "Could not load case details."
    },
    "details": {
      "breadcrumb": "Task/Case Details",
      "title": "Task/Case Details",
      "loading": "Loading task details…",
      "caseDetailsLoadFailed": "Unable to load case details. Please try again later.",
      "coverNotePdfFailed": "Cover note PDF could not be loaded.",
      "startMissingIds": "Cannot start: missing case request id or user task id.",
      "startFailed": "Start failed.",
      "startSuccess": "Task started.",
      "closureValidateFailed": "Unable to validate closure action.",
      "fileReferenceNumber": "File Reference Number",
      "currentStage": "Current Stage",
      "physicalFileCustody": "Physical File Custody",
      "linkedFileRef": "Linked File Ref. No.",
      "workflowProgress": "Workflow Progress",
      "legendCompleted": "Completed",
      "legendCurrent": "Current",
      "legendPending": "Pending",
      "tabCaseDetails": "Case Details",
      "tabCaseUpdate": "Case Update",
      "tabDocuments": "Documents",
      "tabCommunications": "Communications",
      "tabCaseMinutes": "Case Minutes",
      "tabDraftLetter": "Draft Letter",
      "tabSubTasks": "Sub Tasks",
      "tabFileMovementLog": "File Movement Log",
      "tabInvolvement": "Involvement",
      "tabAuditLog": "Audit Log",
      "fileMovementTitle": "File Movement Log Details",
      "dateTime": "Date & Time",
      "event": "Event",
      "fileCustody": "File Custody",
      "qrCheckIn": "QR Check-In",
      "qrCheckOut": "QR Check-Out",
      "noFileMovement": "No file movement activity found for this case request.",
      "loadingQr": "Loading QR…",
      "qrUnavailable": "QR code unavailable",
      "qrAlt": "Case request cover note QR code",
      "viewCoverNote": "View Cover Note",
      "preparing": "Preparing…",
      "printCoverNote": "Print Cover Note",
      "workflowActions": "Workflow Actions",
      "reviewForwardHint": "Use Forward to send this review task to another officer.",
      "completeHint": "Select any optional actions before completing. Click Complete to complete this task/case.",
      "submitHint": "Select any optional actions before submitting. Click {{submitLabel}} to complete and advance this task/case.",
      "forward": "Forward",
      "revert": "Revert",
      "reject": "Reject",
      "closure": "Closure",
      "complete": "Complete",
      "submit": "Submit",
      "checking": "Checking…",
      "starting": "Starting…",
      "start": "Start",
      "started": "Started",
      "blockingSubTasks": "There are pending sub tasks in this workflow stage. Please complete them to continue.",
      "closureAlreadyClicked": "You have already selected a closure approver for this task.",
      "statusInProgress": "In progress",
      "custodyPendingDocumentArrival": "Pending document arrival",
      "communications": {
        "loading": "Loading communications…",
        "loadFailed": "Failed to load communications.",
        "invalidCaseRequest": "Case request id is missing or invalid.",
        "addComment": "Add a Comment",
        "addCommentPlaceholder": "Add a Comment...",
        "adding": "Adding…",
        "addSuccess": "Comment added successfully.",
        "addFailed": "Could not add comment.",
        "commentRequired": "Please enter a comment.",
        "commentTooLong": "Comment must be {{max}} characters or fewer.",
        "commentInvalid": "Comment contains invalid characters.",
        "characters": "characters",
        "visibleToExternal": "Visible to External Agency",
        "cancelTitle": "Cancel Changes",
        "cancelMessage": "Are you sure you want to cancel? Any unsaved changes will be lost.",
        "onHold": "On Hold",
        "resume": "Resume",
        "holdSuccess": "Task put on hold successfully.",
        "holdFailed": "Could not put task on hold.",
        "resumeSuccess": "Task resumed successfully.",
        "resumeFailed": "Could not resume task.",
        "visibleExternalWarningTitle": "Visible to External Agency required",
        "visibleExternalWarningMessage": "Please check 'Visible to External Agency' so the external agency is aware why the task is being put on hold, then add your comment before using On Hold.",
        "rtiExtension": {
          "requestButton": "Request Extension",
          "resumeButton": "Resume Upon Extension Response",
          "modalTitle": "Request for an Extension",
          "reasonLabel": "Reason for Requesting an Extension",
          "reasonPlaceholder": "Enter the reason for requesting an extension…",
          "reasonRequired": "Reason for Requesting an Extension is required.",
          "reasonTooLong": "Reason must be {{max}} characters or fewer.",
          "confirmTitle": "Submit Extension Request",
          "confirmMessage": "Are you sure you want to submit this extension request? The case will be placed on hold until you resume upon receiving a response from the external agency.",
          "requestSuccess": "Extension request submitted successfully.",
          "requestFailed": "Could not submit extension request."
        }
      }
    },
    "modals": {
      "forward": {
        "title": "Forward Task",
        "physicalFileMovement": "Physical File Movement Required",
        "selectDocumentMover": "Select Document Mover",
        "selectDocumentMoverRequired": "Select Document Mover is required.",
        "forwardTask": "Forward Task",
        "forwarding": "Forwarding…",
        "forwardSuccess": "Task forwarded successfully.",
        "forwardFailed": "Forwarding failed.",
        "loadUsersFailed": "Failed to load users.",
        "loadMoversFailed": "Failed to load document movers.",
        "discardTitle": "Discard changes?",
        "discardMessage": "Your changes will be lost if you cancel."
      },
      "revert": {
        "title": "Revert Task",
        "revertToStage": "Revert to Stage",
        "selectStage": "Select Stage",
        "selectUser": "Select User",
        "reallocationReason": "Reason to Request Re-allocation",
        "reallocationReasonPlaceholder": "Enter the reason to request the task to be re-allocated to another user",
        "reallocationReasonRequired": "Reason to Request Re-allocation is required.",
        "reallocationReasonTooLong": "Reason must be at most {{max}} characters.",
        "revertTask": "Revert Task",
        "reverting": "Reverting…",
        "revertSuccess": "Task reverted successfully.",
        "revertFailed": "Revert failed.",
        "stageRequired": "Revert to Stage is required.",
        "userRequired": "Select User is required.",
        "userTaskRequired": "User task id is required.",
        "loadStagesFailed": "Failed to load",
        "loadUsersFailed": "Failed to load",
        "loadMoversFailed": "Failed to load",
        "subtaskConfirmTitle": "Subsidiary tasks in progress",
        "subtaskConfirmMessage": "One or more subsidiary tasks are still in progress. Reverting this task may affect those subsidiary tasks. Do you want to continue?",
        "subtaskWarning": "One or more subsidiary tasks are still in progress. Confirm before reverting to proceed."
      }
    },
    "createCaseRequest": {
      "breadcrumb": "Create Case Request",
      "title": "Create Case Request",
      "subtitle": "Complete the multi-step form below to submit a new case request.",
      "stepLabel": "Step {{num}}",
      "stepCaseOverview": "Case Overview",
      "stepChildGuardian": "Child & Guardian",
      "stepIncidentEvidence": "Incident & Evidence",
      "stepSubmissionDelivery": "Submission & Delivery",
      "stepUploadDocuments": "Upload Documents",
      "step01Title": "Step 01 – Case Overview",
      "step02Title": "Step 02 – Child & Guardian Information",
      "step03Title": "Step 03 – Incident & Evidence",
      "step04Title": "Step 04 – Submission & Physical File Delivery",
      "step05Title": "Step 05 – Upload Documents",
      "requestDetails": "Request Details",
      "requestCategory": "Request Category",
      "subject": "Subject",
      "subjectPlaceholder": "Enter a short title of the case",
      "description": "Description",
      "descriptionPlaceholder": "Enter a detailed description of the request",
      "caseIntakeDetails": "Case Intake Details",
      "caseSource": "Case Source",
      "selectCaseSource": "Select case source",
      "province": "Province",
      "selectProvince": "Select Province",
      "childDetails": "Child Details",
      "childName": "Name of the Child",
      "childNamePlaceholder": "Full name of the child",
      "childDob": "Date of Birth of the Child",
      "gender": "Gender",
      "selectGender": "Select gender",
      "guardianName": "Guardian Name",
      "guardianNamePlaceholder": "Full name of the parent or legal guardian",
      "incidentDetails": "Incident Details",
      "incidentDate": "Incident Occurred Date",
      "incidentLocation": "Incident Location",
      "incidentLocationPlaceholder": "Describe the location where the incident occurred",
      "relationshipConfidentiality": "Relationship & Confidentiality",
      "relationshipToChild": "Relationship to Child",
      "selectRelationship": "Select relationship",
      "confidentiality": "Confidentiality",
      "markConfidential": "Mark this request as Confidential",
      "deliveryMethodSection": "Select Delivery Method for Physical File",
      "deliveryMethod": "Delivery Method",
      "upload": "Upload",
      "dragDrop": "Drag and drop files here",
      "or": "or",
      "browseFiles": "Browse Files",
      "dummyUploadNote": "Dummy upload list in this build.",
      "submitRequest": "Submit Request"
    }
  },
  "workflow": {
    "management": "Workflow Management",
    "templates": {
      "breadcrumb": "Workflow Templates",
      "title": "Workflow Templates",
      "createNew": "+ Create New Workflow Template",
      "templateName": "Workflow Template Name",
      "templateNamePlaceholder": "Enter workflow template name",
      "selectFileCategory": "Select file category",
      "selectSubFileCategory": "Select sub file category",
      "selectStatus": "Select Status",
      "allocationOfficer": "Allocation Officer",
      "selectAllocationOfficer": "Select allocation officer",
      "tableTitle": "Workflow Template Details",
      "workflowCode": "Workflow Code",
      "workflowTemplateName": "Workflow Template Name",
      "version": "Version",
      "lastUpdatedBy": "Last Updated by",
      "lastUpdatedAt": "Last Updated at",
      "viewTemplate": "View workflow template",
      "editTemplate": "Edit workflow template",
      "duplicateTemplate": "Duplicate workflow template",
      "deleteTemplate": "Delete workflow template",
      "duplicating": "Duplicating...",
      "deleteTitle": "Delete Workflow Template",
      "entityLabel": "workflow template"
    },
    "kpi": {
      "breadcrumb": "KPI Configuration",
      "title": "KPI Configuration",
      "workflowTemplateName": "Workflow Template Name",
      "workflowStage": "Workflow Stage",
      "kpisTitle": "Key Performance Indicators (KPIs)",
      "timeToComplete": "Time to Complete (TTC)",
      "timeToRemind": "Time to Remind (TTR)",
      "timeToEscalate": "Time to Escalate (TTE)",
      "days": "Days",
      "hours": "Hours"
    },
    "escalationRules": {
      "breadcrumb": "Escalation Rules",
      "title": "Escalation Rules",
      "workflowTemplateName": "Workflow Template Name",
      "workflowStage": "Workflow Stage",
      "hierarchyTitle": "Escalation Hierarchy",
      "reminderRecipient": "Reminder Recipient",
      "escalationLevel1": "Escalation Level 1 Recipient",
      "escalationLevel2": "Escalation Level 2 Recipient",
      "selectUsers": "Select User(s)",
      "selectUserRoles": "Select User Role(s)",
      "notificationOptions": "Notification Options",
      "systemNotification": "System notification",
      "emailNotification": "Email notification"
    },
    "designer": {
      "title": "Workflow Template Designer",
      "loading": "Loading workflow template…",
      "loadFailed": "Unable to load workflow template.",
      "back": "Back",
      "saveDraft": "Save Draft",
      "validating": "Validating…",
      "validateWorkflow": "Validate Workflow",
      "activating": "Activating…",
      "activateWorkflow": "Activate Workflow",
      "versionNo": "Version No.",
      "status": "Status",
      "statusDraft": "Draft",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "letterTemplate": "Letter Template",
      "selectLetterTemplate": "Select Letter Template",
      "selectFileCategoryFirst": "Select File Category first",
      "selectSubFileCategoryFirst": "Select Sub File Category first",
      "noSubFileCategoriesAvailable": "No sub file categories available",
      "draftVersionCodeNote": "Until this workflow template is activated, the Version Number and the Workflow Code displayed here will be temporarily assigned ones.",
      "activeOfficerEditNote": "Only the Allocation Officer can be changed.",
      "saveAllocationOfficer": "Save",
      "allocationOfficerSaved": "Allocation Officer updated successfully.",
      "allocationOfficerUnchanged": "Select a different Allocation Officer before saving.",
      "allocationOfficerSaveFailed": "Unable to save the Allocation Officer change. Please try again.",
      "activeConflictWarning": "A workflow template already exists for this File Category and Sub File Category combination. Please make sure that you are not attempting to replace an existing active workflow template.",
      "canvasAriaLabel": "Workflow canvas",
      "start": "START",
      "end": "End",
      "addNext": "+ Add Next Stage",
      "removeStage": "Remove Stage",
      "stageBadge": "STAGE {{num}}",
      "newStage": "New Stage",
      "defaultStages": {
        "allocationOfficerAssignment": "Allocation Officer Assignment",
        "closure": "Closure",
        "returnToAllocationOfficer": "Return to Allocation Officer"
      },
      "stageProperties": "Workflow Stage Properties",
      "selectedStage": "Selected Stage",
      "stageName": "Stage Name",
      "enterStageName": "Enter stage name",
      "stageOption": "Stage {{num}} - {{label}}",
      "selectStageHint": "Select a stage on the canvas to configure its properties.",
      "viewRoutingRules": "View Routing Rules",
      "configureRoutingRules": "Configure Routing Rules",
      "viewKpis": "View KPIs",
      "configureKpis": "Configure KPIs",
      "viewEscalationRules": "View Escalation Rules",
      "configureEscalationRules": "Configure Escalation Rules",
      "viewAssignment": "View Assignment",
      "configureAssignment": "Configure Assignment",
      "templateUpdates": "Workflow Template Updates",
      "createdUpdatedAt": "Created/Updated at",
      "createdUpdatedBy": "Created/Updated By",
      "cancelWorkflowTitle": "Cancel Workflow Template",
      "cancelWorkflowMessage": "Are you sure you want to cancel? Unsaved changes will be lost.",
      "replaceActiveTitle": "Replace Active Workflow Template",
      "replaceActiveMessage": "Another active workflow template exists for this file category and sub file category. Do you want to deactivate it and activate this workflow?",
      "routingSaved": "Routing rules saved successfully.",
      "kpisSaved": "KPIs saved successfully.",
      "escalationSaved": "Escalation rules saved successfully.",
      "closureSaved": "Closure assignment saved successfully.",
      "draftSaved": "Workflow Template is saved as a draft successfully.",
      "activated": "Workflow Template activated successfully. It is now available for task assignment.",
      "validationResultTitle": "Workflow Validation Result",
      "returnToDesigner": "Return to Workflow Template Designer",
      "routing": {
        "title": "Configure Routing Rules",
        "loading": "Loading routing rules…",
        "defaultNextStage": "Default Next Stage",
        "allowedRevertStages": "Allowed Revert Stages",
        "selectStages": "Select stage(s)",
        "cancelTitle": "Cancel Routing Configuration",
        "cancelMessage": "Are you sure you want to cancel configuring routing rules?"
      },
      "kpiModal": {
        "title": "Configure KPIs",
        "cancelTitle": "Cancel KPI Configuration",
        "cancelMessage": "Are you sure you want to cancel configuring KPIs?",
        "ttcPlaceholder": "e.g. 14",
        "ttrPlaceholder": "e.g. 12",
        "ttePlaceholder": "e.g. 16"
      },
      "escalation": {
        "title": "Configure Escalation Rules",
        "cancelTitle": "Cancel Escalation Configuration",
        "cancelMessage": "Are you sure you want to cancel configuring escalation rules?"
      },
      "assignment": {
        "title": "Configure Assignment",
        "cancelTitle": "Cancel Assignment Configuration",
        "cancelMessage": "Are you sure you want to cancel configuring assignment?",
        "selectUserRole": "Select User Role",
        "assignedUser": "Assigned User"
      },
      "errors": {
        "templateNameRequired": "Workflow Template Name is required.",
        "fileCategoryRequired": "File Category is required.",
        "subFileCategoryRequired": "Sub File Category is required.",
        "allocationOfficerRequired": "Allocation Officer is required."
      }
    }
  },
  "mailRoom": {
    "breadcrumb": "Case Submission Requests",
    "title": "Case Submission Requests",
    "loadFailed": "Could not load case submission requests.",
    "tableTitle": "Case Submission Request Details",
    "physicalFileStatus": "Physical File Status",
    "fileDeliveryMethod": "File Delivery Method",
    "fileMovementDateTime": "File Movement Date & Time",
    "physicalFileCustody": "Physical File's Current Custody",
    "viewCoverNote": "View Cover Note"
  },
  "recordRoom": {
    "breadcrumb": "Completed Files",
    "title": "Completed Files",
    "loadFailed": "Could not load completed files.",
    "tableTitle": "Completed File Details",
    "caseCompletedAt": "Case Completed at",
    "physicalFileStatus": "Physical File Status",
    "fileMovementDateTime": "File Movement Date & Time",
    "physicalFileCustody": "Physical File's Current Custody",
    "storageLocation": "Storage Location",
    "viewCoverNote": "View Cover Note",
    "coverNoteUnavailable": "Cover note unavailable (missing case request id)",
    "updateStorageLocation": "Update Storage Location"
  },
  "qrScanningLog": {
    "breadcrumb": "QR Scanning Log",
    "title": "QR Scanning Log",
    "tableTitle": "QR Scan Event Details",
    "fileRef": "File Ref.",
    "fileCategory": "File Category",
    "subFileCategory": "Sub File Category",
    "event": "Event",
    "eventAt": "Event Date & Time",
    "systemAutomated": "System Automated",
    "viewResult": "View Result",
    "view": "View",
    "caseRequestId": "Case Request ID",
    "checkedInBy": "Checked in By",
    "role": "Role",
    "checkedInAt": "Checked in At",
    "destination": "Destination",
    "receiverName": "Receiver Name",
    "divisionUnit": "Division / Unit",
    "designation": "Designation",
    "proceedToScanQr": "Proceed to Scan QR",
    "scanQrCode": "Scan QR Code",
    "scanInstruction": "Point the QR Scanner Device at the QR code on the physical file to check in and acknowledge receipt of physical file. Make sure the QR Scanner Device is connected through the USB cable. Upon successful QR scanning, the File Reference Number should appear below.",
    "scanInstructionDetail": "Position the QR code within the scanner frame to validate the physical file and proceed with the check-in process.",
    "scanPlaceholder": "QR scanner preview area"
  },
  "dashboards": {
    "breadcrumb": "Dashboards & Reporting",
    "title": "Dashboards",
    "subtitle": "Role-based workload, SLA signals, and bottleneck view (mock data).",
    "reportingPeriod": "Reporting period",
    "last7Days": "Last 7 days",
    "last30Days": "Last 30 days",
    "last90Days": "Last 90 days",
    "savedPreferences": "Saved preferences",
    "preferencesHint": "Filters persist for your session; auto-refresh can be wired when APIs are available (FR61).",
    "openTasks": "Open tasks",
    "openTasksHint": "Across all assigned workflows",
    "slaAtRisk": "SLA at risk",
    "slaAtRiskHint": "Within TTR window",
    "overdue": "Overdue",
    "overdueHint": "Past TTE — review escalations",
    "avgStageDuration": "Avg. stage duration",
    "avgStageDurationHint": "Rolling 30 days",
    "workloadGraphTitle": "Workload by workflow (graphical summary)",
    "activeCount": "{{count}} active",
    "workloadTableTitle": "Workload detail (tabular)",
    "workflowColumn": "Workflow",
    "activeTasksColumn": "Active tasks",
    "workflows": {
      "standardProsecutionAdvice": "Standard prosecution advice",
      "civilReviewContract": "Civil review — contract",
      "advisoryHumanRights": "Advisory — human rights"
    }
  },
  "allocationDashboard": {
    "from": "From",
    "to": "To",
    "apply": "Apply",
    "showingRange": "Showing: {{from}} – {{to}}",
    "caseTrackingPanel": "Case Tracking Panel",
    "casesNoun": "cases",
    "colFileRef": "File Ref. No.",
    "colFileCategory": "File Category",
    "colSubFileCategory": "Sub File Category",
    "colSubmittedAgency": "Submitted Agency",
    "colSubmittedAt": "Submitted at",
    "colWorkflowStage": "Workflow Stage",
    "colAllocationOfficer": "Allocation Officer",
    "colAssignedOfficer": "Assigned Officer",
    "colSupervisor": "Supervisor",
    "colStateAttorney": "State Attorney",
    "colTaskStatus": "Task Status",
    "colUrgencyLevel": "Urgency Level",
    "colActions": "Actions",
    "viewCaseDetails": "View Task/Case Details",
    "viewCaseTimeline": "View Case Timeline",
    "auditModalTitle": "Case Timeline",
    "auditColDateTime": "Date & Time",
    "auditColActivityBy": "Activity By",
    "auditColAction": "Action",
    "noAuditLogs": "No audit log entries found."
  },
  "sgDashboard": {
    "breadcrumb": "Dashboard",
    "title": "Dashboard",
    "subtitle": "Allocation and monitoring overview for submitted cases.",
    "charts": {
      "urgency": "Cases by Urgency Level",
      "urgencyTip": "All submitted cases by Urgency Level, within {{from}} to {{to}} period.",
      "status": "Cases by Status",
      "statusTip": "All submitted cases by status, at their current workflow stage, within {{from}} to {{to}} period.",
      "category": "Cases by File Category & Sub File Category",
      "categoryTip": "All submitted cases by File Category & Sub File Category, within {{from}} to {{to}} period."
    },
    "kpis": {
      "submitted": "Submitted",
      "submittedTip": "Total number of cases that are submitted through Extranet & Intranet portals, within {{from}} to {{to}} period.",
      "pendingAssignment": "Pending Assignment",
      "pendingAssignmentTip": "Total number of cases that are pending initial allocation and requested to be re-allocated, out of all submitted cases, within {{from}} to {{to}} period.",
      "assignedInProgress": "Assigned & In Progress",
      "assignedInProgressTip": "Total number of cases that are already assigned and currently in progress, out of all submitted cases, within {{from}} to {{to}} period.",
      "highUrgency": "High Urgency Level",
      "highUrgencyTip": "Total number of cases that are marked as Urgency Level = High out of all submitted cases, within {{from}} to {{to}} period.",
      "escalated": "Escalated",
      "escalatedTip": "Total number of cases that have been escalated at their current workflow stage, out of all submitted cases, within {{from}} to {{to}} period.",
      "kpiCompliant": "KPI Compliant",
      "kpiCompliantTip": "Total number of cases that remain KPI-Compliant at their current workflow stage, out of all submitted cases, within {{from}} to {{to}} period.",
      "completed": "Completed",
      "completedTip": "Total number of cases that have been completed, out of all submitted cases, within {{from}} to {{to}} period."
    }
  },
  "operationalDashboard": {
    "breadcrumb": "Dashboard",
    "title": "Dashboard",
    "subtitle": "Your assigned cases overview (mock data until APIs are connected).",
    "charts": {
      "urgency": "Cases by Urgency Level",
      "urgencyTip": "All cases assigned to me by Urgency Level, within {{from}} to {{to}} period.",
      "status": "Cases by Status",
      "statusTip": "All cases assigned to me by status, at their current workflow stage, within {{from}} to {{to}} period.",
      "category": "Cases by File Category & Sub File Category",
      "categoryTip": "All cases assigned to me by File Category & Sub File Category, within {{from}} to {{to}} period."
    },
    "kpis": {
      "assignedInProgress": "Assigned & In Progress",
      "assignedInProgressTip": "Total number of cases that are already assigned to me, out of all submitted cases, within {{from}} to {{to}} period.",
      "highUrgency": "High Urgency Level",
      "highUrgencyTip": "Total number of cases that are marked as Urgency Level = High out of all cases assigned to me, within {{from}} to {{to}} period.",
      "escalated": "Escalated",
      "escalatedTip": "Total number of cases that have been escalated at their current workflow stage, out of all cases assigned to me, within {{from}} to {{to}} period.",
      "kpiCompliant": "KPI Compliant",
      "kpiCompliantTip": "Total number of cases that remain KPI-Compliant at their current workflow stage, out of all cases assigned to me, within {{from}} to {{to}} period.",
      "completed": "Completed",
      "completedTip": "Total number of cases that have been completed, out of all cases assigned to me, within {{from}} to {{to}} period."
    }
  },
  "reports": {
    "breadcrumb": "Reports",
    "previewTitle": "Report Preview",
    "records": "records",
    "reset": "Reset",
    "search": "Search",
    "generateReport": "Generate Report",
    "generating": "Generating…",
    "generateSuccess": "Report generated successfully.",
    "generateFailed": "Could not generate report.",
    "exportFailed": "Could not export report.",
    "searchFailed": "Could not load report data.",
    "dateValidation": {
      "fromFuture": "From date cannot be in the future.",
      "toFuture": "To date cannot be in the future.",
      "fromAfterTo": "From date cannot be after To date."
    },
    "exportOptions": "Export options",
    "exportAs": "Export as",
    "exportAsPdf": "Export as PDF",
    "exportAsExcel": "Export as Excel",
    "exportFormatPdf": "PDF",
    "exportFormatExcel": "Excel",
    "exportStub": "{{format}} export will be available when the reporting API is connected.",
    "filters": {
      "userRoles": "User Role(s)",
      "selectUserRoles": "Select User Role(s)",
      "userNames": "User Name(s)",
      "selectUserNames": "Select User Name(s)",
      "fileCategories": "File Category(s)",
      "selectFileCategories": "Select File Category(s)",
      "subFileCategories": "Sub File Category(s)",
      "selectSubFileCategories": "Select Sub File Category(s)",
      "divisionsUnits": "Division(s) / Unit(s)",
      "selectDivisionsUnits": "Select Division(s) / Unit(s)",
      "submittedAgency": "Submitted Agency",
      "selectAgency": "Select Agency",
      "taskStatus": "Task Status",
      "selectStatus": "Select Status",
      "urgencyLevel": "Urgency Level",
      "selectUrgencyLevel": "Select Urgency Level",
      "workflowStage": "Workflow Stage",
      "selectStage": "Select Stage",
      "workflowStages": "Workflow Stage(s)",
      "selectWorkflowStages": "Select Workflow Stage(s)",
      "all": "All",
      "workflowTemplateNames": "Workflow Template Name(s)",
      "selectWorkflowTemplates": "Select Workflow Template(s)",
      "allocationOfficer": "Allocation Officer(s)",
      "selectAllocationOfficer": "Select Allocation Officer(s)",
      "assignedOfficer": "Assigned Officer",
      "selectAssignedOfficer": "Select Assigned Officer",
      "supervisor": "Supervisor",
      "selectSupervisor": "Select Supervisor",
      "workflowTemplateStatus": "Workflow Template Status(s)",
      "selectWorkflowTemplateStatus": "Select Workflow Template Status(s)",
      "typeToSearch": "Type at least 3 characters to search",
      "clearSelection": "Clear all selections",
      "from": "From",
      "to": "To"
    },
    "upr": {
      "title": "User Performance Report",
      "colUserName": "User Name",
      "colUserRoles": "User Role(s)",
      "colDivisionUnit": "Division / Unit",
      "colAssigned": "Assigned",
      "colEscalated": "Escalated",
      "colCompleted": "Completed"
    },
    "ctr": {
      "title": "Case Tracking Report",
      "colFileRef": "File Ref. No.",
      "colFileCategory": "File Category",
      "colSubFileCategory": "Sub File Category",
      "colSubmittedAgency": "Submitted Agency",
      "colSubmittedAt": "Submitted at",
      "colWorkflowStage": "Workflow Stage",
      "colAllocationOfficer": "Allocation Officer",
      "colAssignedOfficer": "Assigned Officer",
      "colSupervisor": "Supervisor",
      "colTaskStatus": "Task Status",
      "colUrgencyLevel": "Urgency Level"
    },
    "wpr": {
      "title": "Workflow Performance Report",
      "colWorkflowCode": "Workflow Code",
      "colWorkflowTemplateStatus": "Workflow Template Status",
      "colWorkflowTemplateName": "Workflow Template Name",
      "colFileCategory": "File Category",
      "colSubFileCategory": "Sub File Category",
      "colAllocationOfficer": "Allocation Officer",
      "colWorkflowStage": "Workflow Stage",
      "colCasesReceived": "Cases Received",
      "colCompleted": "Completed",
      "colInProgress": "In Progress",
      "colOverdue": "Overdue",
      "colEscalated": "Escalated"
    }
  },
  "audit": {
    "breadcrumb": "Audit Logs",
    "title": "Audit Logs",
    "generating": "Generating…",
    "exportPdf": "Export as PDF",
    "exportCsv": "Export as CSV",
    "filters": "Filters",
    "activityFrom": "Activity From",
    "activityTypes": "Activity Type(s)",
    "selectActivityTypes": "Select Activity Type(s)",
    "activityPerformedBy": "Activity Performed by",
    "selectActorNames": "Select the name(s)",
    "noLogsFound": "No audit logs found.",
    "activityType": "Activity Type",
    "summary": "Summary",
    "targetEntity": "Target Entity",
    "target": "Target",
    "showingRange": "Showing {{start}} to {{end}} of {{total}} audit logs",
    "justNow": "Just now",
    "minutesAgo": "{{count}} min ago",
    "minutesAgo_plural": "{{count}} mins ago",
    "hoursAgo": "{{count}} hour ago",
    "hoursAgo_plural": "{{count}} hours ago",
    "yesterday": "Yesterday",
    "daysAgo": "{{count}} days ago"
  },
  "caseScenarios": {
    "breadcrumb": "Case Scenarios",
    "title": "Case Scenarios",
    "loading": "Loading case scenarios…",
    "none": "No active case scenarios with a PDF are available.",
    "loadFailed": "Could not load case scenarios.",
    "viewPdf": "View PDF",
    "pdfTitle": "Case Scenario Document",
    "loadingPdf": "Loading PDF…",
    "pdfLoadFailed": "Could not load the case scenario PDF."
  },
  "notifications": {
    "breadcrumb": "Notifications",
    "title": "Notifications",
    "markAllRead": "Mark all as Read",
    "marking": "Marking…",
    "allTab": "All Notifications ({{count}})",
    "unreadTab": "Unread ({{count}})",
    "loading": "Loading notifications…",
    "noUnread": "No unread notifications.",
    "none": "No notifications.",
    "loadFailed": "Could not load notifications.",
    "markAllFailed": "Could not mark notifications as read.",
    "markReadFailed": "Could not mark notification as read.",
    "defaultTitle": "Notification",
    "caseRef": "Case reference",
    "showingRange": "Showing {{start}} to {{end}} of {{total}} notification",
    "showingRange_plural": "Showing {{start}} to {{end}} of {{total}} notifications",
    "templates": {
      "caseAssignment": {
        "title": "Case Assignment",
        "body": "A task or case ({{ref}}) has been assigned to your workflow stage. Please review the details and proceed with the required actions."
      }
    }
  },
  "caseRequests": {
    "breadcrumb": "Case Requests",
    "title": "Case Requests",
    "subtitle": "View and track the status of all requests submitted by your agency.",
    "createCaseRequest": "Create Case Request",
    "activeTab": "Active Cases",
    "completedTab": "Completed Cases",
    "tableTitle": "Case Request Details",
    "newNotificationLegend": "New notification received",
    "deleteTitle": "Delete Case Request",
    "deleteMessage": "Are you sure you want to delete? This action cannot be undone.",
    "loadDraftFailed": "Failed to load draft.",
    "deleteDraftFailed": "Failed to delete draft. Please try again.",
    "deleteDraftSuccess": "Draft deleted successfully.",
    "duplicateFailed": "Failed to duplicate case. Please try again.",
    "duplicateSuccess": "Case duplicated successfully. A new draft has been created.",
    "coverNoteSubmittedOnly": "Cover note is only available for submitted requests.",
    "coverNoteLoadFailed": "Could not load cover note.",
    "downloading": "Downloading",
    "downloadPdf": "Download as PDF",
    "viewRequest": "View Request",
    "coverNote": "Cover Note",
    "qrNote": "QR code for file intake, tracking and cover note verification.",
    "fileReferenceNumber": "File Reference Number",
    "requestSubmittedAt": "Request Submitted at",
    "submittedAgency": "Submitted Agency",
    "subFileCategoryLabel": "Sub File Category: {{value}}",
    "summaryTitle": "Summary of Request Details",
    "caseSource": "Case Source",
    "connectedRef": "Connected AGD File Reference Number",
    "accusedName": "Accused/ Suspect Name",
    "applicableAreas": "Applicable Area(s)",
    "urgencyLevel": "Urgency Level",
    "deadline": "Deadline",
    "urgencyJustification": "Urgency Justification",
    "documentsDeclared": "Documents Declared",
    "noCoverNote": "No cover note available for this case.",
    "removing": "Removing",
    "print": "Print",
    "loadingCoverNote": "Loading cover note…",
    "coverNoteUnavailable": "Cover note details are unavailable.",
    "qrGenerationFailed": "QR generation failed",
    "divisionUnit": "Division / Unit",
    "statusLabels": {
      "submitted": "Submitted",
      "draft": "Draft",
      "inProgress": "In Progress",
      "registered": "Registered",
      "review": "Review",
      "completed": "Completed",
      "rejected": "Rejected",
      "notStarted": "Not Started"
    }
  },
  "wizard": {
    "createCaseRequest": "Create Case Request",
    "createSubtitle": "Complete the form below, step by step, to submit a new case request.",
    "reviewBeforeSubmission": "Review Before Submission",
    "reviewTitle": "Review Case Request Details",
    "reviewSubtitle": "Please review all captured information before submitting this request to AGD.",
    "stepBarLabel": "STEP {{num}}",
    "reviewStepLabel": "Step {{num}}",
    "childUnder16": "Child is under 16 years",
    "notAvailable": "Not available",
    "accusedSuspect": "Accused / Suspect {{num}}",
    "confirm": {
      "main": "I confirm the above information is correct",
      "hint": "Please confirm before submitting this request to AGD."
    },
    "nav": {
      "back": "< Back",
      "next": "Next >",
      "saveAsDraft": "Save as Draft",
      "reviewBeforeSubmissionBtn": "Review Before Submission >",
      "submitRequest": "Submit Request",
      "submitting": "Submitting…",
      "cancelCaseRequest": "Cancel Case Request",
      "cancelConfirm": "Are you sure you want to cancel? Any unsaved changes will be lost.",
      "draftSaved": "Case Request has been saved as a draft.",
      "draftSaveFailed": "Failed to save draft.",
      "submitSuccess": "Case Request submitted successfully.",
      "submitFailed": "Submission failed.",
      "fillRequiredFields": "Please fill all the required fields on this screen."
    },
    "sections": {
      "caseCategorization": "Case Categorization",
      "caseIntakeDetails": "Case Intake Details",
      "caseDetails": "Case Details",
      "categorization": "Categorization",
      "victimDetails": "Victim Details",
      "offenceDetails": "Offence Details",
      "timeline": "Timeline",
      "requestSubmitterDetails": "Request Submitter's Details",
      "physicalFileDeliveryMethod": "Physical File Delivery Method",
      "partyDetails": "Party Details",
      "incidentMatterDetails": "Incident/ Matter Details",
      "requesterDetails": "Requester Details",
      "informationRequestDetails": "Information Request Details",
      "additionalInformation": "Additional Information",
      "petitionerDetails": "Petitioner Details",
      "respondentDetails": "Respondent Details",
      "accusedPersonDetails": "Accused Person Details",
      "legalExtraditionCaseDetails": "Legal & Extradition Case Details",
      "uploadDocuments": "Upload Documents",
      "partiesInvolved": "Parties Involved",
      "submission": "Submission"
    },
    "placeholders": {
      "selectFileCategory": "Select File Category",
      "selectSubFileCategory": "Select Sub File Category",
      "selectApplicableAreas": "Select Applicable Area(s)",
      "briefDescriptionOfCase": "Brief description of the case",
      "sourceOfCase": "Source of case",
      "selectProvince": "Select Province",
      "selectDistrict": "Select District",
      "selectCountry": "Select Country",
      "loadingCountries": "Loading countries…",
      "incomingOutgoing": "Incoming / Outgoing",
      "policeMagistrateRef": "Police / magistrate reference no.",
      "commaSeparatedReferences": "Comma-separated references",
      "courtReferenceNumber": "Court reference number",
      "connectedAgdHint": "If you are unaware of the relevant Connected AGD File Reference Number, check the 'Available' checkbox.",
      "briefDescriptionAdviceSought": "Brief description — advice sought",
      "selectCorporateInstitute": "Select Corporate Institute",
      "enterOtherInstituteName": "Enter Other Institute Name",
      "enterExternalReferenceNumber": "Enter External Reference Number",
      "commaSeparatedReferenceNumbers": "Comma-separated reference numbers",
      "includeConnectedCaseDetails": "Include connected case details",
      "enterConnectedCaseNumber": "Enter Connected Case Number",
      "enterConnectedAgdFileRef": "Enter Connected AGD File Reference Number",
      "uploadDocument": "Upload Document",
      "enterAccusedName": "Enter accused name",
      "enterVictimName": "Enter Name of the Victim",
      "selectNationality": "Select Nationality",
      "loadingNationalities": "Loading nationalities…",
      "selectCountryOfOrigin": "Select Country of Origin",
      "selectGender": "Select Gender",
      "selectCustodyStatus": "Select Custody Status",
      "loadingCustodyStatuses": "Loading custody statuses…",
      "custodialAuthorityHint": "CID or relevant law enforcement",
      "selectUrgencyLevel": "Select Urgency Level",
      "urgencyJustificationReason": "Reason the case needs urgent attention",
      "docSkipReason": "Enter Reason (Mention if document is not uploaded)",
      "specifyDeliveryMethod": "Please specify delivery method",
      "enterPlaintiffApplicantName": "Enter Plaintiff / Applicant Name",
      "enterDefendantRespondentName": "Enter Defendant / Respondent Name",
      "enterLegalOfficerNameInCharge": "Enter Name of the Legal Officer/ Officer In-Charge",
      "otherRelatedInstitutionsHint": "Other related institutions connected to the matter",
      "enterInstitutionName": "Enter institution name",
      "addCorporation": "+ Add",
      "remove": "Remove",
      "contactNumberExample": "07XXXXXXXX",
      "otherRelatedInstitutionsPublicPrivateHint": "Other related public or private institutions connected to the matter",
      "specifyCourtType": "Specify court type",
      "enterCourtName": "Enter name of the court",
      "nameOfTheCourt": "Name of the court",
      "detailedLegalIssueDescription": "Detailed description of the legal issue",
      "selectNextStep": "Select next step",
      "enterNextStepOther": "Enter other next step of the case",
      "enterRespondentNames": "Enter Respondent Name(s)",
      "enterRespondentAddress": "Enter Respondent Address",
      "enterNumberOfRespondents": "Enter Number of Respondents",
      "enterPetitionerName": "Enter Name",
      "enterAttorneyName": "Enter Attorney Name",
      "selectRespondentType": "Select Respondent Type",
      "enterRequestorName": "Enter name of requestor",
      "enterNicOrPassport": "Enter NIC or passport number",
      "enterAddress": "Enter address",
      "enterEmailAddress": "Enter email address",
      "enterPublicAuthorityName": "Enter public authority name",
      "describeRequestedInformation": "Describe the information being requested",
      "enterTimePeriodIfApplicable": "Enter time period (if applicable)",
      "selectPreferredLanguage": "Select Preferred Language",
      "provideJustification": "Provide justification",
      "additionalNotesOptional": "Any additional notes (optional)",
      "enterPlaceOfOffence": "Enter place of offence",
      "enterAccusedSuspectName": "Enter Accused/Suspect Name",
      "selectStatus": "Select Status",
      "specifyStatus": "Specify status",
      "enterUrgencyJustification": "Enter urgency justification",
      "caseSourceOther": "Case Source (Other)",
      "selectMagistrateCourt": "Select Magistrate Court",
      "selectHighCourt": "Select High Court",
      "selectPoliceStation": "Select Police Station"
    },
    "fields": {
      "fileCategory": "File Category",
      "subFileCategory": "Sub File Category",
      "applicableAreas": "Applicable Area(s)",
      "available": "Available",
      "description": "Description",
      "caseSource": "Case Source",
      "province": "Province",
      "district": "District",
      "highCourtName": "High Court Name",
      "magistrateCourtName": "Magistrate Court Name",
      "policeStation": "Police Station",
      "yourReferenceNumber": "Your Reference Number (External)",
      "otherExternalReferences": "Other External Reference Number(s)",
      "caseNumber": "Case Number",
      "connectedMatters": "Are there any connected matters (Cases)?",
      "connectedMattersShort": "Connected matters",
      "connectedCaseNumber": "Connected Case Number",
      "connectedAgdFileRef": "Connected AGD File Reference Number",
      "victimName": "Name of the Victim",
      "dateOfBirth": "Date of Birth",
      "age": "Age",
      "gender": "Gender",
      "dateOfOffence": "Date of Offence",
      "placeOfOffence": "Place of Offence",
      "accusedDetailsAvailable": "Accused/Suspect Details Available",
      "accusedSuspects": "Accused / Suspects",
      "urgencyLevel": "Urgency Level",
      "deadline": "Deadline",
      "deadlineIfAny": "Deadline (if any)",
      "urgencyJustification": "Urgency Justification",
      "submittedDivisionUnit": "Submitted Division/ Unit",
      "submittedDivisionUnitNoSpace": "Submitted Division/Unit",
      "submittedAgencyName": "Submitted Agency Name",
      "designation": "Designation",
      "submittedBy": "Submitted by",
      "emailAddress": "Email Address",
      "contactNumber": "Contact Number",
      "physicalFileDeliveryMethod": "Physical File Delivery Method",
      "deliveryMethod": "Delivery Method",
      "otherDeliveryMethod": "Other Delivery Method",
      "instituteType": "Institute Type",
      "appealMatter": "Appeal Matter",
      "originalCourt": "Original Court",
      "judgementOrder": "Judgement / Order",
      "corporateInstitute": "Corporate Institute",
      "otherInstituteName": "Other Institute Name",
      "plaintiffApplicantName": "Plaintiff / Applicant Name",
      "defendantRespondentName": "Defendant / Respondent Name",
      "selectOneOfFollowing": "Select one of the following",
      "otherInvolvedInstitutions": "Other Involved Institutions",
      "legalOfficerName": "Name of the Legal Officer / Officer In-Charge",
      "legalOfficerNameAlt": "Name of the Legal Officer/ Officer In-Charge",
      "hasActionInstituted": "Has action been instituted?",
      "courtType": "Court Type",
      "courtTypeOther": "Court Type (Other)",
      "courtName": "Court Name",
      "publicCorporationNames": "Public Corporation Name(s)",
      "publicCorporationName": "Public Corporation Name",
      "subjectOfDispute": "Subject of the Dispute",
      "incidentOccurredDate": "Incident Occurred Date",
      "nextStepOfCase": "Next Step of the Case",
      "nextStepOfCaseIfApplicable": "Next Step of the Case (if Applicable)",
      "nextDateOfCase": "Next Date of the Case",
      "countryInvolved": "Country Involved",
      "directionOfRequest": "Direction of Request",
      "accusedName": "Name of the Accused",
      "nationality": "Nationality",
      "countryOfOrigin": "Country of Origin",
      "passportIdNumber": "Passport/ID Number",
      "currentCustodyStatus": "Current Custody Status",
      "custodialAuthority": "Custodial Authority",
      "lastKnownLocation": "Last Known Location",
      "arrestWarrantAvailable": "Arrest Warrant Available",
      "warrantReference": "Warrant Reference",
      "applicableTreatyArrangement": "Applicable Treaty/Arrangement",
      "requestorName": "Name of Requestor",
      "nicPassportNumber": "NIC/ Passport Number",
      "isSriLankanCitizen": "Is the requestor a citizen of Sri Lanka?",
      "address": "Address",
      "specificPublicAuthorityName": "Specific Public Authority Name",
      "informationRequestedTimePeriod": "Information Requested Time Period",
      "requestedInformationDetails": "Requested Information Details",
      "preferredMethodOfAccess": "Preferred Method of Access",
      "preferredLanguageForResponse": "Preferred Language for Response",
      "involvesLifeOrPersonalLiberty": "Does this request involve life or personal liberty of a citizen?",
      "justification": "Justification",
      "additionalNotes": "Additional Notes",
      "caseMatter": "Case Matter",
      "name": "Name",
      "nicIdentificationNumber": "NIC / Identification Number",
      "email": "Email",
      "representedByAttorney": "Represented by Attorney",
      "attorneyName": "Attorney Name",
      "attorneyContactNumber": "Attorney's Contact Number",
      "respondentNames": "Respondent Name(s)",
      "respondentType": "Respondent Type",
      "numberOfRespondents": "Number of Respondents",
      "respondentAddress": "Respondent Address",
      "partyBodyType": "Party Body Type",
      "status": "Status",
      "petitionerName": "Petitioner Name",
      "nic": "NIC",
      "attorneyContact": "Attorney Contact",
      "citizenOfSriLanka": "Citizen of Sri Lanka",
      "involvesLifeOrPersonalLibertyShort": "Involves Life or Personal Liberty",
      "hasPreviousAdvice": "Has previous advice been received?",
      "hasPreviousAdviceOnMatter": "Has previous advice been received on this matter?",
      "previousAdviceAttachment": "Previous Advice Attachment",
      "previousAdviceAttachmentIfYes": "If yes, attach previous advice",
      "noPreviousAdviceDocuments": "No previous advice documents uploaded.",
      "connectedAdviceCase": "Connected Advice Case?",
      "connectedAdviceCaseDetails": "Connected Advice Case Details",
      "connectedCaseRelevant": "Is there any connected case relevant to the advice sought?",
      "connectedCaseDetails": "If yes, include the case details aspect (party details)",
      "connectedMattersAdvises": "Are there any connected matters (Advises/Cases)?",
      "isAppealMatter": "Is this an appeal matter?",
      "judgementOrderShort": "Judgement/Order",
      "governmentDepartment": "Government Department",
      "corporation": "Corporation",
      "criminalMatter": "Criminal Matter",
      "civilMatter": "Civil Matter",
      "governmentMinistryDepartment": "Government Ministry / Department / Other Unincorporated Body",
      "publicCorporationStatutory": "Public Corporation / Statutory Board / State Owned Entity / Other Incorporated Body",
      "governmentMinistryDepartmentAlt": "Government Ministry/ Department/Other Unincorporated Body",
      "publicCorporationStatutoryAlt": "Public Corporation/Statutory Board/State Owned Entity/Other Incorporated Body",
      "accusedSuspectName": "Accused / Suspect Name",
      "accusedSuspectStatus": "Accused / Suspect Status",
      "statusOther": "Status (Other)",
      "reason": "Reason",
      "petitionerAddress": "Petitioner Address",
      "nextStepOther": "Other Next Step of the Case",
      "preferredLanguage": "Preferred Language"
    },
    "documents": {
      "documentType": "Document Type",
      "status": "Status",
      "fileOrReason": "File / Reason",
      "uploaded": "Uploaded",
      "notUploaded": "Not Uploaded",
      "noDocumentsDeclared": "No documents declared.",
      "uploading": "Uploading…",
      "loadingChecklist": "Loading document checklist…",
      "selectCategoryForDocs": "Select a file category to load required documents.",
      "noDocsConfigured": "No documents are configured for the selected sub file category."
    },
    "edit": "Edit",
    "criminal": {
      "steps": {
        "1": "Case Overview",
        "2": "Victim Details",
        "3": "Offence & Accused Details",
        "4": "Submission & Physical File Delivery",
        "5": "Upload Documents"
      }
    },
    "criminalAppellate": {
      "steps": {
        "1": "Case Overview",
        "2": "Party Details",
        "3": "Timeline",
        "4": "Submission & Physical File Delivery",
        "5": "Upload Documents"
      }
    },
    "civilLitigation": {
      "steps": {
        "1": "Case Overview",
        "2": "Party Details",
        "3": "Incident Details",
        "4": "Submission & Physical File Delivery",
        "5": "Upload Documents"
      }
    },
    "civilAppellate": {
      "steps": {
        "1": "Case Overview",
        "2": "Party Details",
        "3": "Timeline",
        "4": "Submission & Physical File Delivery",
        "5": "Upload Documents"
      }
    },
    "civilAdvise": {
      "steps": {
        "1": "Case Overview",
        "2": "Timeline",
        "3": "Submission & Physical File Delivery",
        "4": "Upload Documents"
      }
    },
    "attorneyGeneral": {
      "steps": {
        "1": "Case Overview",
        "2": "Party Details",
        "3": "Incident Details",
        "4": "Victim Details",
        "5": "Offence & Accused Details",
        "6": "Accused Person Details - Extradition & MLA",
        "7": "Legal & Extradition",
        "8": "Petitioner Details",
        "9": "Right to Information",
        "10": "Timeline",
        "11": "Submission",
        "12": "Upload Documents"
      },
      "stepLines": {
        "5": "Offence & Accused\nDetails",
        "6": "Accused Person Details\nExtradition & MLA",
        "7": "Legal &\nExtradition",
        "8": "Petitioner\nDetails",
        "9": "Right to\nInformation",
        "12": "Upload\nDocuments"
      }
    },
    "extraditionMla": {
      "steps": {
        "1": "Case Overview",
        "2": "Accused Person Details",
        "3": "Legal & Extradition",
        "4": "Timeline",
        "5": "Submission & Physical File Delivery",
        "6": "Upload Documents"
      },
      "reviewSteps": {
        "3": "Legal & Extradition Case Details",
        "1categorization": "Categorization",
        "1intake": "Case Intake Details"
      }
    },
    "nomination": {
      "steps": {
        "1": "Case Overview",
        "2": "Timeline",
        "3": "Submission & Physical File Delivery",
        "4": "Upload Documents"
      }
    },
    "publicPetition": {
      "steps": {
        "1": "Case Overview",
        "2": "Parties Involved",
        "3": "Timeline",
        "4": "Submission & Physical File Delivery",
        "5": "Upload Documents"
      }
    },
    "rightToInformation": {
      "steps": {
        "1": "Case Overview",
        "2": "Timeline",
        "3": "Submission",
        "4": "Upload Documents"
      }
    }
  },
  "notFound": {
    "title": "Page not found",
    "subtitle": "The address may be incorrect or the page was removed.",
    "goToTasks": "Go to Tasks & Cases"
  }
}